import yikeSellLog from '../../node_modules/@imp/package/lib/zyb-yike-utils/yikeSellLog'
import { getQueryofKey, getQueryString } from '../../utils/getUrlParams'
import cuid from './cuid'
import { getParamInFlowPond } from './flow-pond'
import monitorReport from './monitor-report'

const pageUrl = window.location.href
const lastfrom = getQueryofKey('lastfrom')
const orifrom = getQueryofKey('orifrom')

export function checkLastfrom() {
  let invalid = !lastfrom && !!orifrom
  if (invalid) {
    const messageParams = {
      flowPond: yikeSellLog.getFlowPond(),
      i: cuid.getCuid(),
    }
    const message = `当前h5页面链接中有orifrom无lastfrom：${JSON.stringify(
      messageParams
    )}`
    monitorReport.monitorLog({
      system: 'h5',
      serviceName: 'checkUrlParam',
      method: 'checkUrlLastfrom',
      message,
      level: 'notice',
    })
  }
}

function isFissionLastfrom() {
  const parts = Array.isArray(lastfrom)
    ? lastfrom[0].split('_')
    : lastfrom.split('_')
  // lastfrom 形式为 xxx_bd_online_cpsyyyy_zzz
  return (
    parts[1] === 'bd' &&
    parts[2] === 'online' &&
    (parts[3] || '').indexOf('cps') === 0
  )
}

function checkFissionParam() {
  if (!isFissionLastfrom()) {
    return
  }
  const fissionId = getParamInFlowPond('fissionId')
  const afxActId = getParamInFlowPond('afxActId')
  if (!fissionId || !afxActId) {
    const messageParams = {
      flowPond: yikeSellLog.getFlowPond(),
      i: cuid.getCuid(),
    }
    const message = `h5页面分销参数错误，flowPond中fissionId和afxActId为必传参数，参数信息：${JSON.stringify(
      messageParams
    )}`
    monitorReport.monitorLog({
      system: 'h5',
      serviceName: 'checkUrlParam',
      method: 'checkUrlFissionParam',
      message,
      level: 'notice',
    })
  }
}

export function checkFlowPond() {
  checkFissionParam()
}

export default {
  checkLastfrom,
  checkFlowPond,
}
